import { createContext, useContext } from "react";
import type { QueueAsk } from "./envoy";

/**
 * Takes a posting the queue refused for want of a saved resume, to ask for
 * one and queue it after. Null outside ResumeFirstProvider, and for the
 * provider's own second try, which ends in words rather than asking twice.
 */
export const ResumeFirstContext = createContext<((ask: QueueAsk) => void) | null>(null);

export function useResumeFirst(): ((ask: QueueAsk) => void) | null {
    return useContext(ResumeFirstContext);
}
